import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { colors } from '@naf-simba/theme';
import { CompetitionStyleVariant } from '../Competition.types';

export const ImageWrapper = styled.div`
  width: 100%;
  margin: ${spacing.space16} 0;
  border-radius: ${spacing.space12};

  img {
    width: 100%;
    height: auto;
    border-radius: ${spacing.space12};
  }
`;

export const AnswersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space12};
  margin-top: ${spacing.space16};
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const AnswerLabel = styled.span<{ $style: CompetitionStyleVariant; $isSelected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
  border-radius: ${spacing.space8};
  background-color: ${colors.secondary[100]};
  color: ${nafColor.signature.black};

  ${({ $style, $isSelected }) =>
    $style === 'spruce'
      ? css`
          background-color: ${$isSelected ? colors.secondary[900] : colors.secondary[100]};
          color: ${$isSelected ? nafColor.signature.white : nafColor.signature.black};
        `
      : css`
          background-color: ${colors.secondary[100]};
          color: ${nafColor.signature.black};
        `}
`;

export const AnswerButton = styled.button<{ $style: CompetitionStyleVariant; $isSelected: boolean }>`
  padding: ${spacing.space16};
  border: 1px solid ${nafColor.neutral.neutral4};
  border-radius: ${spacing.space8};
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  text-align: left;
  overflow: hidden;
  gap: ${spacing.space12};

  ${({ $style, $isSelected }) =>
    $style === 'spruce'
      ? css`
          background-color: ${$isSelected ? colors.secondary[100] : nafColor.signature.white};
          color: ${nafColor.signature.black};

          &:hover:not(:disabled) ${AnswerLabel} {
            background-color: ${colors.secondary[900]};
            color: ${nafColor.signature.white};
          }
        `
      : css`
          background-color: ${$isSelected ? colors.secondary[900] : nafColor.signature.white};
          color: ${$isSelected ? nafColor.signature.white : nafColor.signature.black};

          &:hover:not(:disabled) {
            color: ${$isSelected ? nafColor.signature.black : nafColor.signature.black};
          }

          &:hover:not(:disabled) ${AnswerLabel} {
            background-color: ${colors.secondary[900]};
            color: ${nafColor.signature.white};
          }
        `}

  &:hover:not(:disabled) {
    background-color: ${nafColor.neutral.neutral2};
  }
`;

export const QuestionContainer = styled.div``;
